import axios from "axios";



const instance = axios.create({

  
  // baseURL: "https://qa.adminserver.voucher.topupx.io",
  baseURL: "https://adminserver.voucher.topupx.io/",
  // baseURL: "http://localhost:3100", //local

});

export default instance;

